import { render, staticRenderFns } from "./TableOKRs.vue?vue&type=template&id=8e708072"
import script from "./TableOKRs.vue?vue&type=script&lang=js"
export * from "./TableOKRs.vue?vue&type=script&lang=js"
import style0 from "./TableOKRs.vue?vue&type=style&index=0&id=8e708072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports